import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    /**
     * Richiede che la stringa sia esattamente del tipo fornito
     */
    exact<T extends string>(compare: T): StringSchema<T>;
  }
}

export interface IExactMeta {
  literalValue: string;
  [key: string]: any;
}

yup.addMethod(
  yup.string,
  'exact',
  function (this: yup.StringSchema, compare: string) {
    return this.default(compare as any)
      .meta({ literalValue: compare } as IExactMeta)
      .test({
        message: 'Il campo ${path} deve essere "' + compare + '".',
        name: 'exact',
        exclusive: true,
        test(value) {
          if (!value || typeof value !== 'string') return false;
          return value === compare;
        },
      });
  },
);
